import { Component } from "@angular/core";
import { MetadataServiceService } from "src/app/_services/metadata-service.service";

@Component({
	selector: "app-pole-autonomie",
	templateUrl: "./personne-agees.component.html",
	styleUrls: ["./personne-agees.component.scss"],
})
export class PersonneAgeeComponent {
	infoBandeau = {
		image: "./../../assets/bandeau-site-web-medico-social.jpg",
		titre: "Personnes âgées",
		breadcrumb: "ACCUEIL > Pôle Autonomie > Personnes âgées",
	};

	constructor(private metadataService: MetadataServiceService) {}

	ngOnInit(): void {
		this.metadataService.updateMetadata({
			title: "Le Patis Fraux - " + this.infoBandeau.titre,
			description: "Le Patis Fraux - " + this.infoBandeau.titre,
		});
	}
}
